<template>
  <div class="basic-tasks-page">
    <!--<ul class="ul">-->
    <!--<li v-for="(item, index) in brands" :key="index" @click="jump(index)">-->
    <!--{{item.letter}}-->
    <!--</li>-->
    <!--</ul>-->

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="— 暂无更多数据 —"
    >
      <div class="d_jump">
        <!--<div class="letter">{{brand.letter}}</div>-->
        <div class v-for="(item, key) in BrandList" :key="key">
          <div class="item bottom-line">
            <div class="dis">
              <img
                :src="
                  item.brandLogo
                    ? item.brandLogo
                    : 'https://j.weizan.cn/youxiang/images/stage_img.png'
                "
              />
              <div class="curr two-nowrap">{{ item.brandName }}</div>
            </div>
            <div class="btn">
              <van-button class="set" size="small" round @click="setBrand"
                >设置</van-button
              >
              <van-button
                class="save"
                size="small"
                round
                @click="savebrand(item)"
                >保存</van-button
              >
            </div>
          </div>

          <!--<div v-show="index===indexId && key===keyId">-->
          <div>
            <div class="field">
              <div class="input line">
                <div>浏览数量</div>
                <van-field
                  type="number"
                  v-model.number="item.viewNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>浏览惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.viewPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>裂变数量</div>
                <van-field
                  type="number"
                  v-model.number="item.fissionNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>裂变惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.fissionPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>

            <div class="field">
              <div class="input line">
                <div>报名数量</div>
                <van-field
                  type="number"
                  v-model.number="item.enrollmentNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>报名惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.enrollmentPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>

            <div class="field">
              <div class="input line">
                <div>售券数量</div>
                <van-field
                  type="number"
                  v-model.number="item.cardNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>售券惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.cardPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>秒杀数量</div>
                <van-field
                  type="number"
                  v-model.number="item.seckillUserNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>秒杀惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.seckillUserPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>集赞数量</div>
                <van-field
                  type="number"
                  v-model.number="item.thumbNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>集赞惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.thumbPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>

            <div class="field">
              <div class="input line">
                <div>进入直播间数量</div>
                <van-field
                  type="number"
                  v-model.number="item.liveViewNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>进入直播间惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveViewPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播下订</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOrderCusNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播下订惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOrderCusPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播自签单订单</div>
                <van-field
                  type="number"
                  v-model.number="item.liveSelfOrderNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播自签单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveSelfOrderPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播贡献单订单</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOtherOrderNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播贡献单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOtherOrderPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播自签转单</div>
                <van-field
                  type="number"
                  v-model.number="item.liveSelfOrderChangeNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播自签转单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveSelfOrderChangePenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播贡献转单</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOtherOrderChangeNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播贡献转单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.liveOtherOrderChangePenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>过程自签单</div>
                <van-field
                  type="number"
                  v-model.number="item.processSelfOrderNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>过程自签单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.processSelfOrderPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>过程贡献单</div>
                <van-field
                  type="number"
                  v-model.number="item.processDevoteOrderNum"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>过程贡献单惩罚金</div>
                <van-field
                  type="number"
                  v-model.number="item.processDevoteOrderPenalty"
                  :class="staff_css ? 'brand-focus' : ''"
                  :readonly="!staff_css"
                />
              </div>
            </div>
            <div class="field">
              <div class="input line">
                <div>直播预约</div>
                <van-field
                    type="number"
                    v-model.number="item.appointmentNum"
                    :class="staff_css ? 'brand-focus' : ''"
                    :readonly="!staff_css"
                />
              </div>
              <div class="input line">
                <div>直播预约惩罚金</div>
                <van-field
                    type="number"
                    v-model.number="item.appointmentPenalty"
                    :class="staff_css ? 'brand-focus' : ''"
                    :readonly="!staff_css"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="home-over-btn">
      <router-link
        :to="{
          name: 'kpi.home',
          query: { user_id: user_id, kpi_uid: kpi_userid, act_id: activity_id },
        }"
      >
        <img src="https://j.weizan.cn/youxiang/images/home-over.png" />
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      // user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      step_id: 0,
      user: null,
      kpi_user: null,
      page: 1,
      loading: false,
      finished: true,
      brands: [],
      brandstep: {},
      indexId: null,
      keyId: null,
      show: false,
      num: 2,
      punish: 0.01,
      staff_css: false,
      // 品牌参数
      brandStepVO: {
        viewNum: 0,
        viewPenalty: 0,
        fissionNum: 0,
        fissionPenalty: 0,
        enrollmentNum: 0,
        enrollmentPenalty: 0,
        cardNum: 0,
        cardPenalty: 0,
        seckillUserNum: 0,
        seckillUserPenalty: 0,
        thumbNum: 0,
        thumbPenalty: 0,
        liveViewNum: 0,
        liveViewPenalty: 0,
        liveOrderCusNum: 0,
        liveOrderCusPenalty: 0,
        liveSelfOrderNum: 0,
        liveSelfOrderPenalty: 0,
        liveOtherOrderNum: 0,
        liveOtherOrderPenalty: 0,
        liveSelfOrderChangeNum: 0,
        liveSelfOrderChangePenalty: 0,
        liveOtherOrderChangeNum: 0,
        liveOtherOrderChangePenalty: 0,
        processSelfOrderNum: 0,
        processSelfOrderPenalty: 0,
        processDevoteOrderNum: 0,
        processDevoteOrderPenalty: 0,
        appointmentNum: 0,
        appointmentPenalty: 0,
      },
      BrandList: [],
    };
  },
  created() {
    this.step_id = this.$route.query.step_id;
    this.getQueryStepDetail();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取当前阶段任务信息，准备编辑
    async getQueryStepDetail() {
      var id = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/query_brand_step_list?stepId=${id}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.BrandList = res.data;
      }
    },
    async savebrand(item) {
      let res = await this.$http.post(`/v1/taskmanage/update_bs`, item);
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("设置成功！");
      }
    },
    setBrand() {
      this.staff_css = true;
    },
  },
};
</script>

<style lang="less">
.basic-tasks-page {
  .staff-focus,
  .brand-focus {
    .van-field__control {
      background-color: #eeeeee;
      border-radius: 2px;
      text-align: left !important;
    }
  }
  padding-bottom: 20px;
  .ul {
    height: 100%;
    position: fixed;
    right: 0px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    li {
      padding: 2px 5px;
      color: #999999;
      font-size: 12px;
    }
  }
  .d_jump {
    font-size: 12px;
    .letter {
      padding: 3px 10px;
    }
    .item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #ffffff;
      padding: 10px;
      padding-right: 20px;
      .dis {
        display: flex;
        align-items: center;
        max-width: 55%;
        img {
          width: 60px;
          min-width: 60px;
          max-width: 60px;
          height: 40px;
        }
        .curr {
          margin-left: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
      .btn {
        max-width: 45%;
        display: flex;
        .van-button--small {
          color: #ffffff;
          margin-right: 10px;
        }
        .set {
          background-color: #f58022;
          height: 26px;
          line-height: 24px;
        }
        .save {
          background-color: #5293fd;
          height: 26px;
          line-height: 24px;
        }
      }
    }
  }
  .field {
    /*将两个单位并列*/
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    .list {
      padding: 5px 15px;
      padding-right: 20px;
      width: 50%;
      font-size: 12px;
    }
    .list:nth-child(odd) {
      border-right: 1px dashed #ebedf0;
      .van-field__control {
        color: #5293fd;
      }
    }
    .line {
      padding: 7px 15px;
      width: 50%;
      font-size: 12px;
    }
  }
  .input {
    /*将两个输入框水平放置*/
    display: flex;
    padding: 10px 15px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    color: #323232;
    .van-cell {
      width: 40%;
      font-size: 18px;
      padding: 0px;
      .van-field__control {
        text-align: right;
        font-size: 14px;
        color: #5293fd;
        padding: 0 5px;
        line-height: 22px;
      }
    }
  }
  .denger {
    .van-field__control {
      color: #eb5211;
    }
  }
}
</style>
